// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"43":"7c284de6","453":"22a1d1a7","585":"a3c88d3e","610":"71049818","950":"4c5f26d3"}[chunkId] + ".chunk.js";
};